import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home", //默认显示
  },
  {
    path: "/home",
    component: (resolve) => require(["../views/home/Home.vue"], resolve),
  },
  {
    path: "/ai/chatgpt",
    component: (resolve) =>
      require(["../views/ai/chatgpt/chatgpt.vue"], resolve),
    meta: {
      title: "Seayouth-AI问答",
    },
  },
  {
    path: "/ai/chatgpt/display",
    component: (resolve) =>
      require(["../views/ai/chatgpt/chatgpt-display.vue"], resolve),
    meta: {
      title: "Seayouth-AI问答广场",
    },
  },
  {
    path: "/ai/art",
    component: (resolve) => require(["../views/ai/art/ai-art.vue"], resolve),
    meta: {
      title: "Seayouth-AI绘画",
    },
  },
  {
    path: "/ai/art/display",
    component: (resolve) =>
      require(["../views/ai/art/ai-art-display.vue"], resolve),
    meta: {
      title: "Seayouth-AI作品展",
    },
  },
  {
    path: "/ai/audio",
    component: (resolve) =>
      require(["../views/ai/audio/ai-audio.vue"], resolve),
    meta: {
      title: "Seayouth-AI音频",
    },
  },
  {
    path: "/ai/audio/display",
    component: (resolve) =>
      require(["../views/ai/audio/ai-audio-display.vue"], resolve),
    meta: {
      title: "Seayouth-AI音乐广场",
    },
  },
  {
    path: "/articles/:articleId",
    component: (resolve) => require(["../views/article/Article.vue"], resolve),
  },
  {
    path: "/archives",
    component: (resolve) => require(["../views/archive/Archive.vue"], resolve),
    meta: {
      title: "归档",
    },
  },
  {
    path: "/albums",
    component: (resolve) => require(["../views/album/Album.vue"], resolve),
    meta: {
      title: "相册",
    },
  },
  {
    path: "/albums/:albumId",
    component: (resolve) => require(["../views/album/Photo.vue"], resolve),
  },
  {
    path: "/tags",
    component: (resolve) => require(["../views/tag/Tag.vue"], resolve),
    meta: {
      title: "标签",
    },
  },
  {
    path: "/categories",
    component: (resolve) =>
      require(["../views/category/Category.vue"], resolve),
    meta: {
      title: "分类",
    },
  },
  {
    path: "/categories/:categoryId",
    component: (resolve) =>
      require(["../views/article/ArticleList.vue"], resolve),
  },
  {
    path: "/tags/:tagId",
    component: (resolve) =>
      require(["../views/article/ArticleList.vue"], resolve),
  },
  {
    path: "/links",
    component: (resolve) => require(["../views/link/Link.vue"], resolve),
    meta: {
      title: "友链列表",
    },
  },
  // {
  //   path: "/about",
  //   component: resolve => require(["../views/about/About.vue"], resolve),
  //   meta: {
  //     title: "关于我"
  //   }
  // },
  {
    path: "/game/emulator",
    component: (resolve) => require(["../views/game/emulator.vue"], resolve),
    meta: {
      title: "Seayouth-游戏模拟器",
    },
  },
  {
    path: "/game/mygames",
    component: (resolve) => require(["../views/game/mygames.vue"], resolve),
    meta: {
      title: "Seayouth-我的游戏",
    },
  },
  {
    path: "/game/warehouse",
    component: (resolve) => require(["../views/game/warehouse.vue"], resolve),
    meta: {
      title: "Seayouth-ROMs库",
    },
  },
  {
    path: "/message",
    component: (resolve) => require(["../views/message/Message.vue"], resolve),
    meta: {
      title: "Seayouth-留言板",
    },
  },
  {
    path: "/toolbox",
    component: (resolve) => require(["../views/toolbox/toolbox.vue"], resolve),
    meta: {
      title: "Seayouth-工具箱",
    },
  },
  {
    path: "/user",
    component: (resolve) => require(["../views/user/User.vue"], resolve),
    meta: {
      title: "Seayouth-个人中心",
    },
  },
  {
    path: "/myNotice",
    component: (resolve) => require(["../views/user/MyNotice.vue"], resolve),
    meta: {
      title: "Seayouth-我的消息",
    },
  },
  {
    path: "/setting",
    component: (resolve) => require(["../views/user/Setting.vue"], resolve),
    meta: {
      title: "Seayouth-设置",
    },
  },
  {
    path: "/log",
    component: (resolve) => require(["../views/user/Log.vue"], resolve),
    meta: {
      title: "Seayouth-日志明细",
    },
  },
  {
    path: "/login",
    component: (resolve) => require(["../views/user/Login.vue"], resolve),
    meta: {
      title: "Seayouth-登录",
    },
  },
  {
    path: "/callback/qq",
    component: (resolve) => require(["../components/OauthLogin.vue"], resolve),
  },
  {
    path: "/callback/gitee",
    component: (resolve) => require(["../components/OauthLogin.vue"], resolve),
  },
  {
    path: "/callback/weibo",
    component: (resolve) => require(["../components/OauthLogin.vue"], resolve),
  },
];

const router = new VueRouter({
  mode: "history",
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
